import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.string.iterator";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import "core-js/modules/es6.array.find";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es7.promise.finally";
import consola from 'consola';
import Prismic from 'prismic-javascript';

function getRef(context, api) {
  var previewRef = context.$cookies.get(Prismic.previewCookie);
  var masterRef = api.refs.find(function (ref) {
    return ref.isMasterRef === true;
  }).ref;
  return previewRef || masterRef;
}

function fetchArticlesByTag(_x, _x2) {
  return _fetchArticlesByTag.apply(this, arguments);
}

function _fetchArticlesByTag() {
  _fetchArticlesByTag = _asyncToGenerator(
  /*#__PURE__*/
  regeneratorRuntime.mark(function _callee(context, params) {
    var locale, query, endPoint, api, ref, response;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            locale = context.state.i18n.currentLocale;
            _context.prev = 1;
            query = [Prismic.Predicates.at('document.type', 'article')];

            if (params) {
              query.push(Prismic.Predicates.at('document.tags', params.tags));
            }

            endPoint = context.state.sharedEnv.payload.prismic;
            _context.next = 7;
            return Prismic.getApi(endPoint);

          case 7:
            api = _context.sent;
            ref = getRef(context, api);
            response = api.query(query, {
              fetch: ['article.image', 'article.date', 'article.description', 'article.main_title', 'article.reading_time', 'article.difficulty'],
              orderings: '[my.article.date desc]',
              lang: locale.iso ? locale.iso.toLowerCase() : '',
              ref: ref
            });
            return _context.abrupt("return", response);

          case 13:
            _context.prev = 13;
            _context.t0 = _context["catch"](1);
            consola.error(_context.t0);
            return _context.abrupt("return", null);

          case 17:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[1, 13]]);
  }));
  return _fetchArticlesByTag.apply(this, arguments);
}

function fetchContent(_x3, _x4) {
  return _fetchContent.apply(this, arguments);
}

function _fetchContent() {
  _fetchContent = _asyncToGenerator(
  /*#__PURE__*/
  regeneratorRuntime.mark(function _callee2(context, params) {
    var locale, query, endPoint, api, ref, response;
    return regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            locale = context.state.i18n.currentLocale;
            _context2.prev = 1;
            query = [Prismic.Predicates.at('document.type', params.type)];

            if (params.slug) {
              query.push(Prismic.Predicates.at("my.".concat(params.type, ".slug"), params.slug));
            }

            if (params.type === 'generic' && params.alias) {
              query.push(Prismic.Predicates.at("my.".concat(params.type, ".alias"), params.alias));
            }

            endPoint = context.state.sharedEnv.payload.prismic;
            _context2.next = 8;
            return Prismic.getApi(endPoint);

          case 8:
            api = _context2.sent;
            ref = getRef(context, api);
            response = api.query(query, {
              lang: locale.iso ? locale.iso.toLowerCase() : '',
              ref: ref
            });
            return _context2.abrupt("return", response);

          case 14:
            _context2.prev = 14;
            _context2.t0 = _context2["catch"](1);
            consola.error(_context2.t0);
            return _context2.abrupt("return", null);

          case 18:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, null, [[1, 14]]);
  }));
  return _fetchContent.apply(this, arguments);
}

function fetchDocumentsById(_x5, _x6) {
  return _fetchDocumentsById.apply(this, arguments);
}

function _fetchDocumentsById() {
  _fetchDocumentsById = _asyncToGenerator(
  /*#__PURE__*/
  regeneratorRuntime.mark(function _callee3(context, ids) {
    var locale, endPoint, api, ref, promises, response;
    return regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            locale = context.state.i18n.currentLocale;
            _context3.prev = 1;
            endPoint = context.state.sharedEnv.payload.prismic;
            _context3.next = 5;
            return Prismic.getApi(endPoint);

          case 5:
            api = _context3.sent;
            ref = getRef(context, api);
            promises = [];
            ids.forEach(function (e) {
              var query = [Prismic.Predicates.at('document.id', e)];
              var response = api.query(query, {
                lang: locale.iso ? locale.iso.toLowerCase() : '',
                ref: ref
              });
              promises.push(response);
            });
            _context3.next = 11;
            return Promise.all(promises);

          case 11:
            response = _context3.sent;
            return _context3.abrupt("return", {
              results: response.map(function (e) {
                return e.results[0];
              })
            });

          case 15:
            _context3.prev = 15;
            _context3.t0 = _context3["catch"](1);
            consola.error(_context3.t0);
            return _context3.abrupt("return", null);

          case 19:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3, null, [[1, 15]]);
  }));
  return _fetchDocumentsById.apply(this, arguments);
}

export { fetchContent, fetchDocumentsById, fetchArticlesByTag };